import { render, staticRenderFns } from "./OcsumPSReport.vue?vue&type=template&id=d222c216&scoped=true"
import script from "./OcsumPSReport.ts?vue&type=script&lang=ts&external"
export * from "./OcsumPSReport.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d222c216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d222c216')) {
      api.createRecord('d222c216', component.options)
    } else {
      api.reload('d222c216', component.options)
    }
    module.hot.accept("./OcsumPSReport.vue?vue&type=template&id=d222c216&scoped=true", function () {
      api.rerender('d222c216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/components/reports/OcsumPSReport/OcsumPSReport.vue"
export default component.exports